import type { ColumnType } from "epsm-api-types/models";

export const getType = (
	type: ColumnType,
): "string" | "number" | "date" | string => {
	switch (type) {
		case "date":
			return "date";
		case "num":
			return "number";

		default:
			return "string";
	}
};
